import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseIcon from '@/components/BaseIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
  size: {
    type: Number,
    default: 21,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseIcon, {
    icon: "loading",
    size: __props.size,
    class: "loading-spinner"
  }, null, 8, ["size"]))
}
}

})